// J2: the Apply now field library's keys as the kit v1.6.0 starts it (firstfund-app/docs/kit/apply-now-content/
// field-library.json), offered as suggestions in "Fields this API needs". The library itself lives in App admin
// (Apply now → Field library) and may hold more keys: any key in the same form can be typed.

export const LIBRARY_KEY = /^[a-z][a-zA-Z0-9]{1,39}$/
export const LENDER_KEY = /^[A-Za-z_][A-Za-z0-9_.]{0,59}$/
export const OPTION_VALUE = /^[a-z0-9][a-z0-9_-]{0,39}$/

export const KIT_FIELDS: { key: string; label: string; group: string }[] = [
  { key: 'maritalStatus', label: 'Marital status', group: 'About you' },
  { key: 'education', label: 'Highest education', group: 'About you' },
  { key: 'fatherName', label: "Father's name", group: 'About you' },
  { key: 'alternateMobile', label: 'Alternate mobile', group: 'About you' },
  { key: 'dependents', label: 'People who depend on you', group: 'About you' },
  { key: 'residenceType', label: 'Your home is', group: 'Your home' },
  { key: 'residenceSince', label: 'Living at this address since', group: 'Your home' },
  { key: 'permanentSame', label: 'Also your permanent address?', group: 'Your home' },
  { key: 'permanentAddress', label: 'Permanent address', group: 'Your home' },
  { key: 'employerName', label: 'Employer or company name', group: 'Your job (salaried)' },
  { key: 'companyType', label: 'Company type', group: 'Your job (salaried)' },
  { key: 'designation', label: 'Your designation', group: 'Your job (salaried)' },
  { key: 'totalExperience', label: 'Total work experience', group: 'Your job (salaried)' },
  { key: 'currentJobSince', label: 'In this job since', group: 'Your job (salaried)' },
  { key: 'salaryMode', label: 'How is your salary paid?', group: 'Your job (salaried)' },
  { key: 'salaryBank', label: 'Bank your salary comes into', group: 'Your job (salaried)' },
  { key: 'officePincode', label: 'Office PIN code', group: 'Your job (salaried)' },
  { key: 'officeEmail', label: 'Work email', group: 'Your job (salaried)' },
  { key: 'businessName', label: 'Business name', group: 'Your business' },
  { key: 'natureOfBusiness', label: 'What does your business do?', group: 'Your business' },
  { key: 'businessRegistrationType', label: 'Business registration or proof', group: 'Your business' },
  { key: 'gstin', label: 'GSTIN', group: 'Your business' },
  { key: 'udyamNumber', label: 'Udyam registration number', group: 'Your business' },
  { key: 'businessEntityType', label: 'Type of business', group: 'Your business' },
  { key: 'businessYears', label: 'Years in this business', group: 'Your business' },
  { key: 'businessCurrentTurnover', label: 'Yearly turnover', group: 'Your business' },
  { key: 'businessAccount', label: 'Current account in business name?', group: 'Your business' },
  { key: 'businessPincode', label: 'Business PIN code', group: 'Your business' },
  { key: 'itrFiled', label: 'Filed ITR for last 2 years?', group: 'Your business' },
  { key: 'loanPurpose', label: 'What is the loan for?', group: 'Your loan and money' },
  { key: 'loanAmountWanted', label: 'Amount you need', group: 'Your loan and money' },
  { key: 'existingEmi', label: 'Existing EMIs a month', group: 'Your loan and money' },
  { key: 'creditCardHeld', label: 'Do you have a credit card?', group: 'Your loan and money' },
]

/** "rented = RENTED" lines ↔ { rented: 'RENTED' }. */
export function parseCodes(text: string): { codes: Record<string, string>; error: string | null } {
  const codes: Record<string, string> = {}
  for (const raw of text.split(/\r?\n/)) {
    const line = raw.trim()
    if (!line) continue
    const i = line.indexOf('=')
    if (i < 0) return { codes, error: `“${line}”: write our value = the lender's code` }
    const ours = line.slice(0, i).trim()
    const theirs = line.slice(i + 1).trim()
    if (!OPTION_VALUE.test(ours)) return { codes, error: `“${ours}”: our option values are lower-case letters, digits, - and _` }
    if (!theirs || theirs.length > 60) return { codes, error: `“${ours}”: the lender's code is 1 to 60 characters` }
    if (ours in codes) return { codes, error: `“${ours}” is there twice` }
    codes[ours] = theirs
  }
  return { codes, error: null }
}

export const codesText = (codes: Record<string, string>) => Object.entries(codes).map(([k, v]) => `${k} = ${v}`).join('\n')
